import React from "react";
import "./ButtonStyle.css";

export default function Button({ children, type, value }) {
  return (
    <button className='button-div btn-link' type={type} value = {value}>
      {children}
    </button>
  );
}
